const filterEvents = (events, filters) => {
    if(!events?.length) return 0;
    if(filters.length > 0)
        events = events.filter(event => {
            return filters.some(filter =>  filter.value === event.activityId);
        });
    return events.map(e => e.count).reduce((a, b) => a + b, 0);
}
export default filterEvents;